// Textos de la suscripción (Configuración, avisos) y del panel de gestión.
// Mismas claves en los tres idiomas; el español es el texto de referencia.
export const suscripcion = {
  es: {
    susTitulo: 'Suscripción',
    susIncluye: 'Acceso completo a todas las secciones, sin límites y en cualquier dispositivo. Cancela cuando quieras. Precio de acceso anticipado: 2,50 $ al mes, y lo conservas mientras mantengas la suscripción.',
    susEstadoPrueba: 'Prueba gratuita · {n} días restantes',
    susEstadoPruebaUno: 'Prueba gratuita · último día',
    susEstadoActiva: 'Activa · se renueva el {fecha}',
    susEstadoCancelando: 'Activa hasta el {fecha} · no se renovará',
    susEstadoImpago: 'Pago pendiente · revisa tu tarjeta (acceso hasta el {fecha})',
    susEstadoPagada: 'Activa hasta el {fecha}',
    susEstadoCaducada: 'Prueba terminada · solo lectura',
    susEstadoCancelada: 'Cancelada · solo lectura',
    susEstadoBloqueada: 'Cuenta bloqueada',
    susEstadoAdmin: 'Administrador · sin límite',
    susActivar: 'Activar suscripción',
    susGestionar: 'Gestionar suscripción',
    susGestionarAyuda: 'Cambiar la tarjeta, ver las facturas o cancelar.',
    susPruebaNota: 'Si la activas durante la prueba, no se te cobra nada hasta que termine.',
    susPagoOk: 'Pago completado. Tu suscripción se activará en unos segundos.',
    susPagoCancelado: 'No se ha completado el pago. Puedes intentarlo cuando quieras.',
    susNoDisponible: 'El pago con tarjeta todavía no está disponible. Contacta con el administrador.',
    susError: 'No se pudo abrir el pago: {msg}',
    susRedirigiendo: 'Abriendo Stripe…',
    susSeguro: 'Pago seguro con Stripe. No guardamos los datos de tu tarjeta.',
    // Panel de gestión
    admUsuarios: 'Usuarios',
    admEnPrueba: 'En prueba',
    admDePago: 'De pago',
    admCaducados: 'Caducados',
    admBloqueados: 'Bloqueados',
    admMrr: 'MRR estimado',
    admMrrAyuda: '{n} de pago × {precio}',
    admBuscar: 'Buscar por nombre o email…',
    admFiltroTodos: 'Todos',
    admFiltroAdmin: 'Admins',
    admEstado: 'Estado',
    admPruebaHasta: 'Prueba hasta el {fecha}',
    admPagadoHasta: 'Pagado hasta el {fecha}',
    admSinFecha: 'Sin fecha',
    admEstadoAdmin: 'Admin',
    admEstadoPago: 'De pago',
    admEstadoCancelando: 'Cancela el {fecha}',
    admEstadoImpago: 'Impago',
    admEstadoPrueba: 'Prueba',
    admEstadoCaducado: 'Caducado',
    admEstadoBloqueado: 'Bloqueado',
    admStripeSin: 'Sin suscripción',
    admUltimoAcceso: 'Último acceso',
    admNunca: 'Nunca',
    admAcceso: 'Acceso de administrador',
    admAccesoDesc: 'Solo entran aquí las cuentas con el rol de administrador, un campo que el cliente no puede modificar (lo protegen las reglas de Firestore). Para que únicamente tu cuenta pueda dar o quitar ese rol, pon tu UID en propietarioUid() de firestore.rules.',
    admTuUid: 'Tu UID',
    admCopiar: 'Copiar',
    admCopiado: 'Copiado',
    admAdmins: 'Cuentas con rol de administrador',
    admResumenStripe: 'Resumen de Stripe',
    admCargarStripe: 'Cargar datos de Stripe',
    admActualizar: 'Actualizar',
    admCargando: 'Cargando…',
    admStripeNoConfigurado: 'Stripe no está configurado todavía (faltan las funciones o las claves). Los pasos están en STRIPE.md.',
    admStripeError: 'No se pudo consultar Stripe: {msg}',
    admSuscripciones: 'Suscripciones',
    admActivas: 'Activas',
    admMrrReal: 'MRR real',
    admImporte: 'Importe',
    admRenovacion: 'Renovación',
    admCancelacion: 'Cancelación',
    admModoPrueba: 'Modo de prueba de Stripe',
    admEnVivo: 'Stripe en vivo',
    admConsultado: 'Consultado a las {hora}',
    admEventos: 'Últimos eventos de Stripe (webhook)',
    admSinEventos: 'Todavía no se ha recibido ningún evento.',
    admTipo: 'Tipo',
    admFecha: 'Fecha',
    admPagos: 'Pagos',
    // ─── Roles, invitaciones y secciones bloqueadas ───
    rolEt_admin: 'ADMIN',
    rolEt_pago: 'SUSCRIPTOR',
    rolEt_invitado: 'INVITADO',
    rolEt_prueba: 'EN PRUEBA',
    rolEt_caducado: 'PRUEBA TERMINADA',
    rolEt_bloqueado: 'BLOQUEADO',
    susEstadoInvitado: 'Cuenta invitada · acceso gratuito',
    susEstadoInvitadoHasta: 'Cuenta invitada · gratis hasta el {fecha}',
    susSoloLecturaAjustes: 'Mientras no actives la suscripción, tus datos quedan en solo lectura: categorías, años y presupuesto no se pueden modificar.',
    bloqMenuAyuda: 'Disponible con la suscripción',
    bloqTituloSeccion: '{seccion} no está incluido en tu cuenta',
    bloqCaducadaTitulo: 'Tu prueba gratuita ha terminado',
    bloqCaducadaTexto: 'Puedes seguir viendo tu Dashboard, pero {seccion} y el resto de secciones quedan en pausa hasta que actives la suscripción ({precio}). Tus datos se conservan intactos.',
    bloqRolTexto: 'Tu cuenta actual no incluye {seccion}. Actívala con la suscripción ({precio}).',
    bloqRolInvitadoTexto: 'Tu cuenta de invitado no incluye {seccion}. Pide al administrador que la habilite.',
    admPestUsuarios: 'Usuarios',
    admPestRoles: 'Roles y permisos',
    admPestInvitaciones: 'Invitaciones',
    admPestActividad: 'Actividad',
    admPestStripe: 'Stripe',
    admPestErrores: 'Errores',
    admInvitados: 'Invitados',
    admEstadoInvitado: 'Invitado',
    admRolesTitulo: 'Qué puede usar cada tipo de cuenta',
    admRolesDesc: 'Marca las secciones que incluye cada tipo de cuenta y si puede editar sus datos. Se aplica al instante a todos los usuarios de ese tipo (también lo hacen cumplir las reglas de la base de datos). Las excepciones de un usuario concreto se ponen desde su ficha en Usuarios.',
    admSeccion: 'Sección',
    admRolPrueba: 'En prueba',
    admRolPago: 'De pago',
    admRolInvitado: 'Invitado',
    admRolCaducado: 'Prueba terminada',
    admRolEscribir: 'Puede editar sus datos',
    admSiempreVisible: 'Configuración siempre está disponible (ahí se activa la suscripción) y Gestión es solo para administradores.',
    admDiasPrueba: 'Días de prueba gratuita',
    admDiasPruebaAyuda: 'Para las cuentas nuevas. Las existentes conservan su fecha; puedes cambiarla usuario a usuario.',
    admGuardarRoles: 'Guardar cambios',
    admRolesGuardado: 'Guardado: ya se aplica a todos los usuarios.',
    admRolesError: 'No se pudo guardar: {msg}',
    admRolesRestaurar: 'Valores por defecto',
    admInvTitulo: 'Invitaciones (cuentas gratuitas)',
    admInvDesc: 'Las cuentas invitadas no pagan: tienen lo que marques para «Invitado» en Roles y permisos, sin fecha límite o hasta la que indiques. Si el correo ya tiene cuenta, pasa a invitado ahora mismo; si no, lo será en cuanto se registre con ese correo.',
    admInvEmail: 'Correo',
    admInvHasta: 'Gratis hasta (opcional)',
    admInvHastaCol: 'Gratis hasta',
    admInvAnadir: 'Invitar',
    admInvPendientes: 'Pendientes de registro',
    admInvSinPendientes: 'No hay invitaciones pendientes.',
    admInvActivos: 'Cuentas invitadas',
    admInvSinActivos: 'Todavía no hay cuentas invitadas.',
    admInvQuitar: 'Quitar invitación',
    admInvSinFecha: 'sin fecha límite',
    admInvRegistrada: 'ya registrado',
    admInvCreada: 'Invitación creada para {email}: tendrá acceso gratuito al registrarse.',
    admInvConvertida: '{email} ya tenía cuenta: ahora es invitado.',
    admInvError: 'No se pudo invitar: {msg}',
    admTipoCuenta: 'Tipo de cuenta y fechas',
    admEstadoActual: 'Ahora mismo',
    admPruebaHastaCampo: 'Prueba gratuita hasta',
    admInvitadoCheck: 'Cuenta invitada (gratuita)',
    admInvitadoHasta: 'Invitado hasta (vacío = sin límite)',
    admSeccionesUsuario: 'Secciones para este usuario',
    admSeccionesUsuarioAyuda: 'Marcadas = puede entrar. Por defecto son las de su tipo de cuenta ({rol}); lo que cambies aquí es una excepción solo para esta persona (* = no viene con su tipo de cuenta).',
    admVistaExtra: 'Sección añadida a este usuario',
    admVistaQuitada: 'Sección quitada a este usuario',
    admErrBorrar: 'Borrar este error',
    admErrVaciar: 'Vaciar lista ({n})',
    admErrVaciarConfirm: '¿Borrar los {n} errores registrados?',
    admErrError: 'No se pudo borrar: {msg}',
    admErrCuentaBorrada: 'Cuenta ya eliminada',
  },
  en: {
    susTitulo: 'Subscription',
    susIncluye: 'Full access to every section, without limits, on any device. Cancel whenever you want. Early-access price: $2.50 a month, locked in for as long as you keep your subscription.',
    susEstadoPrueba: 'Free trial · {n} days left',
    susEstadoPruebaUno: 'Free trial · last day',
    susEstadoActiva: 'Active · renews on {fecha}',
    susEstadoCancelando: 'Active until {fecha} · will not renew',
    susEstadoImpago: 'Payment pending · check your card (access until {fecha})',
    susEstadoPagada: 'Active until {fecha}',
    susEstadoCaducada: 'Trial ended · read only',
    susEstadoCancelada: 'Cancelled · read only',
    susEstadoBloqueada: 'Account blocked',
    susEstadoAdmin: 'Administrator · unlimited',
    susActivar: 'Activate subscription',
    susGestionar: 'Manage subscription',
    susGestionarAyuda: 'Change your card, see invoices or cancel.',
    susPruebaNota: 'If you activate it during the trial, you are not charged until it ends.',
    susPagoOk: 'Payment completed. Your subscription will be active in a few seconds.',
    susPagoCancelado: 'The payment was not completed. You can try again whenever you want.',
    susNoDisponible: 'Card payment is not available yet. Contact the administrator.',
    susError: 'Could not open the payment: {msg}',
    susRedirigiendo: 'Opening Stripe…',
    susSeguro: 'Secure payment with Stripe. We never store your card details.',
    admUsuarios: 'Users',
    admEnPrueba: 'On trial',
    admDePago: 'Paying',
    admCaducados: 'Expired',
    admBloqueados: 'Blocked',
    admMrr: 'Estimated MRR',
    admMrrAyuda: '{n} paying × {precio}',
    admBuscar: 'Search by name or email…',
    admFiltroTodos: 'All',
    admFiltroAdmin: 'Admins',
    admEstado: 'Status',
    admPruebaHasta: 'Trial until {fecha}',
    admPagadoHasta: 'Paid until {fecha}',
    admSinFecha: 'No date',
    admEstadoAdmin: 'Admin',
    admEstadoPago: 'Paying',
    admEstadoCancelando: 'Cancels on {fecha}',
    admEstadoImpago: 'Unpaid',
    admEstadoPrueba: 'Trial',
    admEstadoCaducado: 'Expired',
    admEstadoBloqueado: 'Blocked',
    admStripeSin: 'No subscription',
    admUltimoAcceso: 'Last access',
    admNunca: 'Never',
    admAcceso: 'Administrator access',
    admAccesoDesc: 'Only accounts with the administrator role can enter here, a field the client cannot modify (the Firestore rules protect it). To make sure only your account can grant or revoke that role, put your UID in propietarioUid() in firestore.rules.',
    admTuUid: 'Your UID',
    admCopiar: 'Copy',
    admCopiado: 'Copied',
    admAdmins: 'Accounts with the administrator role',
    admResumenStripe: 'Stripe summary',
    admCargarStripe: 'Load Stripe data',
    admActualizar: 'Refresh',
    admCargando: 'Loading…',
    admStripeNoConfigurado: 'Stripe is not configured yet (functions or keys missing). The steps are in STRIPE.md.',
    admStripeError: 'Could not query Stripe: {msg}',
    admSuscripciones: 'Subscriptions',
    admActivas: 'Active',
    admMrrReal: 'Actual MRR',
    admImporte: 'Amount',
    admRenovacion: 'Renewal',
    admCancelacion: 'Cancellation',
    admModoPrueba: 'Stripe test mode',
    admEnVivo: 'Stripe live',
    admConsultado: 'Queried at {hora}',
    admEventos: 'Latest Stripe events (webhook)',
    admSinEventos: 'No events received yet.',
    admTipo: 'Type',
    admFecha: 'Date',
    admPagos: 'Payments',
    // ─── Roles, invitations and locked sections ───
    rolEt_admin: 'ADMIN',
    rolEt_pago: 'SUBSCRIBER',
    rolEt_invitado: 'GUEST',
    rolEt_prueba: 'ON TRIAL',
    rolEt_caducado: 'TRIAL ENDED',
    rolEt_bloqueado: 'BLOCKED',
    susEstadoInvitado: 'Guest account · free access',
    susEstadoInvitadoHasta: 'Guest account · free until {fecha}',
    susSoloLecturaAjustes: 'Until you activate the subscription your data is read-only: categories, years and budget cannot be changed.',
    bloqMenuAyuda: 'Available with the subscription',
    bloqTituloSeccion: '{seccion} is not included in your account',
    bloqCaducadaTitulo: 'Your free trial has ended',
    bloqCaducadaTexto: 'You can keep viewing your Dashboard, but {seccion} and the other sections are paused until you activate the subscription ({precio}). Your data is kept intact.',
    bloqRolTexto: 'Your current account does not include {seccion}. Unlock it with the subscription ({precio}).',
    bloqRolInvitadoTexto: 'Your guest account does not include {seccion}. Ask the administrator to enable it.',
    admPestUsuarios: 'Users',
    admPestRoles: 'Roles & permissions',
    admPestInvitaciones: 'Invitations',
    admPestActividad: 'Activity',
    admPestStripe: 'Stripe',
    admPestErrores: 'Errors',
    admInvitados: 'Guests',
    admEstadoInvitado: 'Guest',
    admRolesTitulo: 'What each account type can use',
    admRolesDesc: 'Tick the sections each account type includes and whether it can edit its data. It applies instantly to every user of that type (the database rules enforce it too). Exceptions for one user are set from their card in Users.',
    admSeccion: 'Section',
    admRolPrueba: 'On trial',
    admRolPago: 'Paying',
    admRolInvitado: 'Guest',
    admRolCaducado: 'Trial ended',
    admRolEscribir: 'Can edit their data',
    admSiempreVisible: 'Settings is always available (that is where the subscription is activated) and Management is for administrators only.',
    admDiasPrueba: 'Free trial days',
    admDiasPruebaAyuda: 'For new accounts. Existing ones keep their date; you can change it user by user.',
    admGuardarRoles: 'Save changes',
    admRolesGuardado: 'Saved: it now applies to every user.',
    admRolesError: 'Could not save: {msg}',
    admRolesRestaurar: 'Default values',
    admInvTitulo: 'Invitations (free accounts)',
    admInvDesc: 'Guest accounts do not pay: they get whatever you tick for "Guest" in Roles & permissions, with no end date or until the date you set. If the email already has an account it becomes a guest right now; otherwise it will as soon as it signs up with that email.',
    admInvEmail: 'Email',
    admInvHasta: 'Free until (optional)',
    admInvHastaCol: 'Free until',
    admInvAnadir: 'Invite',
    admInvPendientes: 'Pending sign-up',
    admInvSinPendientes: 'No pending invitations.',
    admInvActivos: 'Guest accounts',
    admInvSinActivos: 'No guest accounts yet.',
    admInvQuitar: 'Remove invitation',
    admInvSinFecha: 'no end date',
    admInvRegistrada: 'signed up',
    admInvCreada: 'Invitation created for {email}: free access as soon as they sign up.',
    admInvConvertida: '{email} already had an account: it is now a guest.',
    admInvError: 'Could not invite: {msg}',
    admTipoCuenta: 'Account type and dates',
    admEstadoActual: 'Right now',
    admPruebaHastaCampo: 'Free trial until',
    admInvitadoCheck: 'Guest account (free)',
    admInvitadoHasta: 'Guest until (empty = no limit)',
    admSeccionesUsuario: 'Sections for this user',
    admSeccionesUsuarioAyuda: 'Ticked = can open it. By default those of their account type ({rol}); whatever you change here is an exception for this person only (* = not part of their account type).',
    admVistaExtra: 'Section added for this user',
    admVistaQuitada: 'Section removed for this user',
    admErrBorrar: 'Delete this error',
    admErrVaciar: 'Clear list ({n})',
    admErrVaciarConfirm: 'Delete the {n} logged errors?',
    admErrError: 'Could not delete: {msg}',
    admErrCuentaBorrada: 'Account already deleted',
  },
  de: {
    susTitulo: 'Abonnement',
    susIncluye: 'Voller Zugriff auf alle Bereiche, ohne Limits, auf jedem Gerät. Jederzeit kündbar. Early-Access-Preis: 2,50 $ im Monat, garantiert, solange Sie Ihr Abonnement behalten.',
    susEstadoPrueba: 'Kostenlose Testphase · noch {n} Tage',
    susEstadoPruebaUno: 'Kostenlose Testphase · letzter Tag',
    susEstadoActiva: 'Aktiv · verlängert sich am {fecha}',
    susEstadoCancelando: 'Aktiv bis {fecha} · wird nicht verlängert',
    susEstadoImpago: 'Zahlung ausstehend · prüfen Sie Ihre Karte (Zugriff bis {fecha})',
    susEstadoPagada: 'Aktiv bis {fecha}',
    susEstadoCaducada: 'Testphase beendet · nur Lesen',
    susEstadoCancelada: 'Gekündigt · nur Lesen',
    susEstadoBloqueada: 'Konto gesperrt',
    susEstadoAdmin: 'Administrator · unbegrenzt',
    susActivar: 'Abonnement aktivieren',
    susGestionar: 'Abonnement verwalten',
    susGestionarAyuda: 'Karte ändern, Rechnungen einsehen oder kündigen.',
    susPruebaNota: 'Wenn Sie es während der Testphase aktivieren, wird erst nach deren Ende abgebucht.',
    susPagoOk: 'Zahlung abgeschlossen. Ihr Abonnement ist in wenigen Sekunden aktiv.',
    susPagoCancelado: 'Die Zahlung wurde nicht abgeschlossen. Sie können es jederzeit erneut versuchen.',
    susNoDisponible: 'Die Kartenzahlung ist noch nicht verfügbar. Wenden Sie sich an den Administrator.',
    susError: 'Die Zahlung konnte nicht geöffnet werden: {msg}',
    susRedirigiendo: 'Stripe wird geöffnet…',
    susSeguro: 'Sichere Zahlung mit Stripe. Wir speichern keine Kartendaten.',
    admUsuarios: 'Benutzer',
    admEnPrueba: 'In Testphase',
    admDePago: 'Zahlend',
    admCaducados: 'Abgelaufen',
    admBloqueados: 'Gesperrt',
    admMrr: 'Geschätzter MRR',
    admMrrAyuda: '{n} zahlend × {precio}',
    admBuscar: 'Nach Name oder E-Mail suchen…',
    admFiltroTodos: 'Alle',
    admFiltroAdmin: 'Admins',
    admEstado: 'Status',
    admPruebaHasta: 'Testphase bis {fecha}',
    admPagadoHasta: 'Bezahlt bis {fecha}',
    admSinFecha: 'Kein Datum',
    admEstadoAdmin: 'Admin',
    admEstadoPago: 'Zahlend',
    admEstadoCancelando: 'Endet am {fecha}',
    admEstadoImpago: 'Unbezahlt',
    admEstadoPrueba: 'Testphase',
    admEstadoCaducado: 'Abgelaufen',
    admEstadoBloqueado: 'Gesperrt',
    admStripeSin: 'Kein Abonnement',
    admUltimoAcceso: 'Letzter Zugriff',
    admNunca: 'Nie',
    admAcceso: 'Administratorzugriff',
    admAccesoDesc: 'Nur Konten mit der Administratorrolle gelangen hierher; dieses Feld kann der Client nicht ändern (die Firestore-Regeln schützen es). Damit ausschließlich Ihr Konto diese Rolle vergeben oder entziehen kann, tragen Sie Ihre UID in propietarioUid() in firestore.rules ein.',
    admTuUid: 'Ihre UID',
    admCopiar: 'Kopieren',
    admCopiado: 'Kopiert',
    admAdmins: 'Konten mit Administratorrolle',
    admResumenStripe: 'Stripe-Übersicht',
    admCargarStripe: 'Stripe-Daten laden',
    admActualizar: 'Aktualisieren',
    admCargando: 'Wird geladen…',
    admStripeNoConfigurado: 'Stripe ist noch nicht konfiguriert (Funktionen oder Schlüssel fehlen). Die Schritte stehen in STRIPE.md.',
    admStripeError: 'Stripe konnte nicht abgefragt werden: {msg}',
    admSuscripciones: 'Abonnements',
    admActivas: 'Aktiv',
    admMrrReal: 'Tatsächlicher MRR',
    admImporte: 'Betrag',
    admRenovacion: 'Verlängerung',
    admCancelacion: 'Kündigung',
    admModoPrueba: 'Stripe-Testmodus',
    admEnVivo: 'Stripe live',
    admConsultado: 'Abgefragt um {hora}',
    admEventos: 'Letzte Stripe-Ereignisse (Webhook)',
    admSinEventos: 'Noch keine Ereignisse empfangen.',
    admTipo: 'Typ',
    admFecha: 'Datum',
    admPagos: 'Zahlungen',
    // ─── Rollen, Einladungen und gesperrte Bereiche ───
    rolEt_admin: 'ADMIN',
    rolEt_pago: 'ABONNENT',
    rolEt_invitado: 'GAST',
    rolEt_prueba: 'TESTPHASE',
    rolEt_caducado: 'TEST BEENDET',
    rolEt_bloqueado: 'GESPERRT',
    susEstadoInvitado: 'Gastkonto · kostenloser Zugang',
    susEstadoInvitadoHasta: 'Gastkonto · kostenlos bis {fecha}',
    susSoloLecturaAjustes: 'Bis Sie das Abonnement aktivieren, sind Ihre Daten schreibgeschützt: Kategorien, Jahre und Budget lassen sich nicht ändern.',
    bloqMenuAyuda: 'Mit dem Abonnement verfügbar',
    bloqTituloSeccion: '{seccion} ist in Ihrem Konto nicht enthalten',
    bloqCaducadaTitulo: 'Ihre kostenlose Testphase ist abgelaufen',
    bloqCaducadaTexto: 'Ihr Dashboard bleibt sichtbar, aber {seccion} und die übrigen Bereiche pausieren, bis Sie das Abonnement aktivieren ({precio}). Ihre Daten bleiben erhalten.',
    bloqRolTexto: 'Ihr aktuelles Konto enthält {seccion} nicht. Schalten Sie es mit dem Abonnement frei ({precio}).',
    bloqRolInvitadoTexto: 'Ihr Gastkonto enthält {seccion} nicht. Bitten Sie den Administrator, es freizuschalten.',
    admPestUsuarios: 'Benutzer',
    admPestRoles: 'Rollen & Rechte',
    admPestInvitaciones: 'Einladungen',
    admPestActividad: 'Aktivität',
    admPestStripe: 'Stripe',
    admPestErrores: 'Fehler',
    admInvitados: 'Gäste',
    admEstadoInvitado: 'Gast',
    admRolesTitulo: 'Was jeder Kontotyp nutzen darf',
    admRolesDesc: 'Markieren Sie die Bereiche jedes Kontotyps und ob er seine Daten bearbeiten darf. Gilt sofort für alle Benutzer dieses Typs (die Datenbankregeln setzen es ebenfalls durch). Ausnahmen für einzelne Benutzer legen Sie in deren Karte unter Benutzer fest.',
    admSeccion: 'Bereich',
    admRolPrueba: 'Testphase',
    admRolPago: 'Zahlend',
    admRolInvitado: 'Gast',
    admRolCaducado: 'Test beendet',
    admRolEscribir: 'Darf seine Daten bearbeiten',
    admSiempreVisible: 'Einstellungen sind immer verfügbar (dort wird das Abonnement aktiviert), Verwaltung nur für Administratoren.',
    admDiasPrueba: 'Kostenlose Testtage',
    admDiasPruebaAyuda: 'Für neue Konten. Bestehende behalten ihr Datum; Sie können es pro Benutzer ändern.',
    admGuardarRoles: 'Änderungen speichern',
    admRolesGuardado: 'Gespeichert: gilt jetzt für alle Benutzer.',
    admRolesError: 'Speichern fehlgeschlagen: {msg}',
    admRolesRestaurar: 'Standardwerte',
    admInvTitulo: 'Einladungen (kostenlose Konten)',
    admInvDesc: 'Gastkonten zahlen nicht: Sie erhalten, was Sie unter Rollen & Rechte für „Gast“ markieren, ohne Enddatum oder bis zum angegebenen Datum. Hat die E-Mail schon ein Konto, wird es sofort zum Gast; sonst bei der Registrierung mit dieser E-Mail.',
    admInvEmail: 'E-Mail',
    admInvHasta: 'Kostenlos bis (optional)',
    admInvHastaCol: 'Kostenlos bis',
    admInvAnadir: 'Einladen',
    admInvPendientes: 'Registrierung ausstehend',
    admInvSinPendientes: 'Keine ausstehenden Einladungen.',
    admInvActivos: 'Gastkonten',
    admInvSinActivos: 'Noch keine Gastkonten.',
    admInvQuitar: 'Einladung entfernen',
    admInvSinFecha: 'ohne Enddatum',
    admInvRegistrada: 'registriert',
    admInvCreada: 'Einladung für {email} erstellt: kostenloser Zugang ab der Registrierung.',
    admInvConvertida: '{email} hatte bereits ein Konto: jetzt Gast.',
    admInvError: 'Einladung fehlgeschlagen: {msg}',
    admTipoCuenta: 'Kontotyp und Daten',
    admEstadoActual: 'Aktuell',
    admPruebaHastaCampo: 'Kostenlose Testphase bis',
    admInvitadoCheck: 'Gastkonto (kostenlos)',
    admInvitadoHasta: 'Gast bis (leer = unbegrenzt)',
    admSeccionesUsuario: 'Bereiche für diesen Benutzer',
    admSeccionesUsuarioAyuda: 'Markiert = darf öffnen. Standard sind die Bereiche des Kontotyps ({rol}); Änderungen hier gelten nur für diese Person (* = nicht Teil des Kontotyps).',
    admVistaExtra: 'Für diesen Benutzer hinzugefügter Bereich',
    admVistaQuitada: 'Für diesen Benutzer entfernter Bereich',
    admErrBorrar: 'Diesen Fehler löschen',
    admErrVaciar: 'Liste leeren ({n})',
    admErrVaciarConfirm: 'Die {n} protokollierten Fehler löschen?',
    admErrError: 'Löschen fehlgeschlagen: {msg}',
    admErrCuentaBorrada: 'Konto bereits gelöscht',
  }
};
